module.exports = __webpack_public_path__ + "img/backgroundprofile.c66326a0.jpg";